<template>
 <b-container class="sign-in-col">
  <b-row>
    <b-col>
      <b-tabs content-class="mt-3">
        <b-tab title="Email" active @click="validateEmail">
          <form @submit.prevent="signin('email')">
            <div v-if="$store.state.signin_code === null">
              <b-form-input type="email" name="username" v-model="form.username" placeholder="Email" :state="email_valid_state" @change="validateEmail"/>
              <b-form-input type="number" no-wheel name="account_id" pattern="[0-9]*" v-model="form.account_id" placeholder="Лицевой счет" :state="account_valid_state"/>
              <b-form-input type="number" no-wheel name="pin" pattern="[0-9]*" v-model="form.pin" placeholder="Пин" :state="pin_valid_state"/>
            </div>
            <b-button variant="success" type="submit" :disabled="$store.state.signin_code !== null">Запрос кода</b-button>
          </form>
        </b-tab>
<!--        <b-tab title="Телефон" @click="validatePhone">-->
<!--          <form @submit.prevent="signin('phone')">-->
<!--            <div v-if="$store.state.signin_code === null">-->
<!--              <b-form-input type="text" name="username" v-model="form.username" placeholder="Телефон" :state="phone_valid_state" @change="validatePhone"/>-->
<!--              <b-form-input type="number" no-wheel name="account_id" pattern="[0-9]*" v-model="form.account_id" placeholder="Лицевой счет" :state="account_valid_state"/>-->
<!--              <b-form-input type="number" no-wheel name="pin" pattern="[0-9]*" v-model="form.pin" placeholder="Пин" :state="pin_valid_state"/>-->
<!--            </div>-->
<!--            <b-button variant="success" type="submit" :disabled="$store.state.signin_code !== null">Запрос кода</b-button>-->
<!--          </form>-->
<!--        </b-tab>-->
      </b-tabs>
      <div v-if="$store.state.signin_code">
        <div>Код подтверждения выслан на указанный адрес</div>
        <form @submit.prevent="signin_confirm">
          <b-input type="text" name="pin" v-model="form.code" placeholder="Код"/>
          <b-button variant="success" type="submit">Подтвердить</b-button>
        </form>
      </div>
      <p class="alert-danger" v-if="$store.state.signin_error" id="error">{{ $store.state.signin_error }}</p>
    </b-col>
  </b-row>
 </b-container>
</template>

<script>
export default {
  name: "SignInView",
  data() {
    return {
      phone_valid_state: null,
      email_valid_state: null,
      account_valid_state: null,
      pin_valid_state: null,
      code_valid_state: null,
      counting: false,
      form: {
        username: "",
        account_id: "",
        pin: "",
        code: "",
      },
    };
  },
  methods: {
    startCountdown: function () {
      let timeleft = 10;
      var downloadTimer = setInterval(function(){
        if(timeleft <= 0){
          clearInterval(downloadTimer);
          document.getElementById("countdown").innerHTML = "Finished";
        } else {
          document.getElementById("countdown").innerHTML = timeleft + " seconds remaining";
        }
        timeleft -= 1;
      }, 1000);
    },
    onCountdownEnd: function () {
      this.counting = false;
    },
    signin: function (ntype){
      this.$store.dispatch('signIn',
          {'username': this.form.username, 'account_id': this.form.account_id, 'pin': this.form.pin, 'ntype': ntype})
      this.$store.state.singin_code = true
      this.$store.state.singin_timeout = 0
      this.$store.state.signin_error = null
    },
    signin_confirm: function (){
      this.$store.dispatch('signInConfirm',
          {'code': this.form.code, 'username': this.form.username})
    },
    validatePhone: function (){
      if (this.form.username.length > 0) {
        let phonereg = /\d{10}/;
        if (this.form.username.match(phonereg)) {
          this.phone_valid_state = true
        } else {
          this.phone_valid_state = false
        }
      } else {this.phone_valid_state = null}
    },
    validateEmail: function (){
      if (this.form.username.length > 0) {
        let emailreg = /^(([^<>()[\]\\.,;:\s@]+(\.[^<>()[\]\\.,;:\s@]+)*)|(.+))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        if (this.form.username.match(emailreg)) {
          this.email_valid_state = true
        } else {
          this.email_valid_state = false
        }
      } else {this.email_valid_state = null}
    }

  },
  mounted() {
    this.$store.state.signin_code = null
    this.$store.state.signin_timeout = 0
  }
}
</script>

<style scoped>
  /* hide arrows
   Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
    margin: 0 !important;
  }

  .sign-in-col {
    max-width: 300px;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield !important;
  }
</style>